export const isCookieFirstLoaded = () => window != null && !!window.CookieFirst;
